export default __webpack_public_path__ + "static/media/ic_time.2675b7bb.svg";